import { Box, Typography } from "@mui/material";
import { TaskerRejectOption } from "@t3/shared";

interface RejectOptionDisplayProps {
  option: TaskerRejectOption;
}

export const RejectOptionDisplay = ({ option }: RejectOptionDisplayProps) => {
  return (
    <Box
      sx={{
        flex: "1 1 auto",
        minWidth: 0,
        width: "100%",
        p: 2,
        borderTop: "1px solid #aaa",
        backgroundColor: "rgba(255, 180, 174)",
      }}
    >
      <Typography variant="body2" sx={{ color: "text.primary" }}>
        {option.message}
      </Typography>
    </Box>
  );
};
